import React, { useState } from 'react';
import { usePortalMutation, usePortalDocumentPreview } from '../hooks';
import DocumentCallAction from './DocumentCallAction';
import { MdVisibility, MdCheck, MdClose } from 'react-icons/md';
import { ErrorNotice, Status } from './Feedback';
export default function DocumentCallFile({ base, file, historical = false }) {
  const [reason, setReason] = useState('');
  const preview = usePortalDocumentPreview(`${base}/documentos/${file.id}/visualizar`);
  const decision = usePortalMutation(`${base}/documentos/${file.id}/decisao`);
  const viewDocument = <DocumentCallAction label="Visualizar documento" icon={<MdVisibility />} disabled={!preview.allowed || preview.isLoading} onClick={() => {
    const tab = window.open('', '_blank');
    if (tab) tab.opener = null;
    preview.mutate(undefined, {
      onSuccess: url => { if (tab) tab.location.replace(url); else window.location.assign(url); },
      onError: () => tab?.close(),
    });
  }} />;
  return <div className="portal-call-file">
    <div className="portal-call-file-heading"><div><strong>{file.file_name}</strong><p>{historical ? 'Envio anterior' : 'Envio atual'} · {new Date(file.created_at).toLocaleString('pt-BR')}</p></div><div className="portal-admin-actions"><Status value={file.status} />{historical && viewDocument}</div></div>
    {file.reason && <p className="portal-call-file-reason">{file.reason}</p>}
    <ErrorNotice error={preview.error || decision.error} />
    {!historical && <>
      <label className="form-label portal-call-reason"><span>Justificativa</span><textarea rows={3} className="form-control" value={reason} onChange={e => setReason(e.target.value)} /></label>
      <div className="portal-admin-actions portal-call-review-actions">
        {viewDocument}
        <DocumentCallAction label="Aprovar documento" icon={<MdCheck />} variant="success" disabled={!decision.allowed || decision.isLoading} onClick={() => decision.mutate({ status: 'approved', reason })} />
        <DocumentCallAction label="Recusar documento" icon={<MdClose />} variant="danger" disabled={!decision.allowed || decision.isLoading} onClick={() => decision.mutate({ status: 'rejected', reason })} />
      </div>
    </>}
  </div>;
}
